import { Dialog, DialogContent } from '@mui/material';
import AdmiinLogo from '../../../components/AdmiinLogo/AdmiinLogo';
import { WBFlex, WBIconButton, WBView } from '@admiin-com/ds-web';
import { SearchEntityMobile } from '../../layouts/MainDrawerLayout/components/TopBar/components/SearchBox/SearchEntityMobile';
export type SearchMobileModalProps = {
  open: boolean;
  onClose: () => void;
};

export const SearchMobileModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent sx={{ p: 2 }}>
        <WBView gap={3}>
          <WBFlex justifyContent={'space-between'}>
            <AdmiinLogo />
            <WBIconButton icon="Close" onClick={onClose} />
          </WBFlex>
          <SearchEntityMobile onClick={onClose} />
        </WBView>
      </DialogContent>
    </Dialog>
  );
};
